import { BlastworksClientEvent, ClientController } from "client-controller";
import { FowlEnterSlotBonusState } from "state-machine/states/bonus/slot/fowl-enter-slot-bonus-state";

export class SocialEnterSlotBonusState extends FowlEnterSlotBonusState {
    /**
     * Lock the top bar
     */
    public onEnter(cascadeSkip?: boolean): void {
        ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_START);
        super.onEnter(cascadeSkip);
    }
}
